// services/competitionService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  timeout: 350000,
});

apiClient.interceptors.request.use((config) => {
  let token = '';
  const user = localStorage.getItem('user');
  if (user) {
    try {
      token = JSON.parse(user)?.token || '';
    } catch (_) {}
  }
  if (token && config.headers) config.headers['AuthorizationToken'] = token;
  return config;
});

const unwrap = (data) =>
  data && typeof data === 'object' && 'result' in data ? data.result : data;

class CompetitionService {
  async getCurrentCompetition() {
    const { data } = await apiClient.get('/competitions/current1');
    return unwrap(data);
  }

  async createCompetition(payload) {
    // Get current client timezone (e.g. "Asia/Dubai", "Europe/London")
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const { data } = await apiClient.post('/competitions', {
      ...payload,
      timezone, // ✅ add timezone automatically
    });

    return unwrap(data);
  }

  async endCompetition(payload) {
    // Expecting:
    // { totalAmount: string, totalWinner: string, award: [{minRank, maxRank, amount}] }
    const { data } = await apiClient.post('/competitions/end', payload);
    return unwrap(data);
  }
}

export default new CompetitionService();
